import { useContext } from "react";
import MapContext from "Services/MapProvider";

const useMap = () => {
    return useContext(MapContext);
};

export default useMap;
